export const QUERY_FORM = "QUERY_FORM";
export const QUERY_FORM_SUCCESS = "QUERY_FORM_SUCCESS";
export const QUERY_FORM_FAILED = "QUERY_FORM_FAILED";
